import { render } from "./Peu.vue?vue&type=template&id=ac561e84&scoped=true"
import script from "./Peu.vue?vue&type=script&lang=js"
export * from "./Peu.vue?vue&type=script&lang=js"

import "./Peu.vue?vue&type=style&index=0&id=ac561e84&scoped=true&lang=css"

import exportComponent from "/root/apps/cantic/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ac561e84"]])

export default __exports__